"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectWithLabel = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var id = 0;
function SelectWithLabel(props) {
    var _a = (0, react_1.useState)(), labelId = _a[0], setLabelId = _a[1];
    (0, react_1.useEffect)(function () {
        id++;
        setLabelId('select-with-label-' + id);
    }, []);
    return (react_1.default.createElement(material_1.FormControl, { variant: props.variant, fullWidth: true, style: props.style },
        react_1.default.createElement(material_1.InputLabel, { id: labelId, shrink: true }, props.label),
        react_1.default.createElement(material_1.Select, { labelId: labelId, label: props.label, fullWidth: true, value: props.value, onChange: function (e) { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e.target.value); } }, props.children)));
}
exports.SelectWithLabel = SelectWithLabel;
